import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { cn } from '@/lib/utils'

interface BrandMarkProps {
    className?: string
}

export const BrandMark: FC<BrandMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 40 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            aria-hidden='true'
            className={cn('size-9', className)}
        >
            <rect x='2.5' y='2.5' width='35' height='35' rx='11' className='fill-primary' />
            <path
                d='M9 21.5 H15 L18 13.5 L23 27.5 L26 20.5 H31'
                className='stroke-primary-foreground'
                strokeWidth='2.6'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

interface WordmarkProps {
    className?: string
    markClassName?: string
}

export const Wordmark: FC<WordmarkProps> = ({ className, markClassName }): ReactNode => {
    return (
        <Link
            href='/'
            aria-label='HealthPathCore home'
            className={cn('inline-flex items-center gap-2.5', className)}
        >
            <BrandMark className={markClassName} />

            <span className='font-heading text-lg font-bold tracking-tight text-foreground'>
                HealthPath<span className='text-primary'>Core</span>
            </span>
        </Link>
    )
}
